// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialAttendance = () => {
  const item = window.sessionStorage.getItem("attendance");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const getAttendance = createAsyncThunk(
  "attendance/getAttendance",
  async (obj, { rejectWithValue }) => {
    try {
      let url = `${process.env.REACT_APP_HR_API}attendance`; // Default single-date API
      const params = { branch: obj.branch };

      if (obj.fromDate && obj.toDate) {
        // Use the range-based API when both fromDate and toDate are provided
        url = `${process.env.REACT_APP_HR_API}attendanceByRange`;
        params.startDate = obj.fromDate;
        params.endDate = obj.toDate;
      } else if (obj.date) {
        // Use the single-date API
        params.date = obj.date;
      }

      const res = await axios.get(url, {
        params,
        headers: { Authorization: `Bearer ${obj.token}` },
      });

      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const attendanceSlice = createSlice({
  name: "attendance",
  initialState: {
    attendanceData: initialAttendance(),
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAttendance.fulfilled, (state, action) => {
        state.attendanceData = action.payload;
        sessionStorage.setItem("attendance", JSON.stringify(action.payload));
        // state.bookmarks = action.payload.bookmarks
      })
      .addCase(getAttendance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export default attendanceSlice.reducer;
